import React from "react";
import { defaultCompare } from "logic/DefaultCompare";
const EventFields = ({ fields }) => {
  const fieldNames = Object.keys(fields).sort(defaultCompare);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, fieldNames.map((fieldName) => /* @__PURE__ */ React.createElement("div", { key: fieldName }, /* @__PURE__ */ React.createElement("b", null, fieldName), " ", fields[fieldName])));
};
export default EventFields;
